import { render, staticRenderFns } from "./TableLists.vue?vue&type=template&id=64ea3758&scoped=true&"
import script from "./TableLists.vue?vue&type=script&lang=js&"
export * from "./TableLists.vue?vue&type=script&lang=js&"
import style0 from "./TableLists.vue?vue&type=style&index=0&id=64ea3758&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ea3758",
  null
  
)

export default component.exports